import { delay, put, takeEvery, call, select } from 'redux-saga/effects';
import { RequestWkblVideoListAction } from 'redux/actions/type';
import { REQUEST_WKBL_VIDEO_LIST } from 'redux/actions/types';
import { getAPI } from 'commons/framework/KeyFlowAPIRequest';
import KeyFlowResponse from 'commons/framework/KeyFlowResponse';
import { API } from 'commons/constants/KeyFlowAPI';
import { SearchType } from 'commons/constants/KeyFlowConstants';
import AssetVO from 'commons/vo/AssetVO';
import {
  requestWkblVideoListFailure,
  requestWkblVideoListSuccess,
  throwError,
} from 'redux/actions/actions';
import { PaginationType } from 'commons/framework/type';
import WkblVideoVO from 'commons/vo/WkblVideoVO';
import { AxiosResponse } from 'axios';

function* requestWkblVideoListSaga(action: RequestWkblVideoListAction) {
  try {
    const { param } = action.payload;
    let videoParam: any = param.getParam();

    if (videoParam.season === 'all') {
      const { season, ...rest } = videoParam;
      videoParam = rest;
    }

    const returnCount: number = videoParam.retr;
    const response: AxiosResponse = yield call(getAPI, API.WKBL_VIDEO_SEARCH, videoParam);
    const keyFlowResponse = new KeyFlowResponse(response.data);
    const resultList: WkblVideoVO[] = keyFlowResponse.getResult(WkblVideoVO) as WkblVideoVO[];
    const pagination: PaginationType = keyFlowResponse.page;
    yield put(
      requestWkblVideoListSuccess({
        videoList: resultList,
        pagination,
        returnCount,
      }),
    );
  } catch (error: any | Error) {
    yield put(throwError({ error }));
    yield put(requestWkblVideoListFailure());
  }
}

export function* watchWkblVideoSaga() {
  yield takeEvery(REQUEST_WKBL_VIDEO_LIST, requestWkblVideoListSaga);
}
